import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "control__icon-box" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "control__icon iconfont icontrol-menu" })
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "control-menu__close-icon iconfont isummary-close" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "control-menu__backlink-box" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "control-menu__backlink-icon iconfont iprev" }, null, -1)
const _hoisted_6 = { class: "control-menu__list" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "control-menu__icon iconfont isummary-highlights" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "Highlights and Notes", -1)
const _hoisted_9 = {
  key: 0,
  class: "control-menu__bookmarks-empty"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "control-menu__bookmarks-empty-text" }, [
  /*#__PURE__*/_createTextVNode(" Your bookmarks will appear here. You can create a bookmark by selecting some text and clicking the "),
  /*#__PURE__*/_createElementVNode("span", { class: "control-menu__icon iconfont iflag" }),
  /*#__PURE__*/_createTextVNode(" icon. ")
], -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "control-menu__icon iconfont control-menu__icon-bookmark iflag" }, null, -1)
const _hoisted_13 = { class: "control-menu__bookmarks-text" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "control-menu__icon iconfont isummary-community" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", null, "Discussion", -1)
const _hoisted_16 = {
  key: 1,
  class: "control-menu__unit"
}
const _hoisted_17 = { class: "download-error" }

import { computed, onBeforeMount, Raw, ref } from 'vue'

import { DocTocView } from '@/models/doc.toc'
import { BookNativeStorageView } from '@/models/book.native.storage.view'
import { DocView } from '@/models/doc'

import NativeStorageDownloadButton from '@/app/components/doc/NativeStorageDownloadButton.vue'
import Expandable from './Expandable.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SidebarTOC',
  props: {
    doc: null
  },
  setup(__props: any) {

const props = __props as {
  doc: DocView
};



const view = ref<DocTocView | null>(null)
const nativeStorageView = ref<Raw<BookNativeStorageView> | null>(null)

onBeforeMount(async () => {
  view.value = new DocTocView(props.doc)
  await view.value.init()
  nativeStorageView.value = await BookNativeStorageView.initialize(props.doc)
})

const previewPage = computed(() => {
  return {
    name: props.doc.routeNames().preview,
    params: {
      url_slug: props.doc.url_slug,
    },
  }
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (view.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "control__btn menu-btn",
        title: "Table of contents",
        onClick: _cache[5] || (_cache[5] = ($event: any) => (view.value.show()))
      }, [
        _hoisted_1,
        _createVNode(_Transition, { name: "fade" }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("div", {
              class: "control-menu",
              onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (view.value.clickOutside($event)), ["stop"]))
            }, [
              _createVNode(_Transition, {
                name: "book-toc",
                appear: ""
              }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("div", {
                    class: _normalizeClass(["control-menu__content", { 'control-menu__content--active': view.value.isVisible }])
                  }, [
                    _createElementVNode("a", {
                      class: "control-menu__close",
                      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (view.value.hide()), ["stop"]))
                    }, _hoisted_3),
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_component_router_link, {
                        replace: "",
                        class: "control-menu__backlink",
                        to: _unref(previewPage)
                      }, {
                        default: _withCtx(() => [
                          _hoisted_5,
                          _createTextVNode(" Back to preview page ")
                        ]),
                        _: 1
                      }, 8, ["to"])
                    ]),
                    _createElementVNode("ul", _hoisted_6, [
                      _createElementVNode("li", {
                        class: _normalizeClass([view.value.onePageSummaryWrapperCss(), "control-menu__unit control-menu__one-page"])
                      }, [
                        _createVNode(_component_router_link, {
                          replace: "",
                          to: view.value.onePageSummaryLink(),
                          class: "control-menu__link",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (view.value.menuItemClick()))
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", {
                              class: _normalizeClass([view.value.onePageSummaryCss(), "control-menu__icon iconfont"])
                            }, null, 2),
                            _createElementVNode("span", null, _toDisplayString(__props.doc.pages[0].title), 1)
                          ]),
                          _: 1
                        }, 8, ["to"])
                      ], 2),
                      (view.value.hasFullSummary())
                        ? (_openBlock(), _createBlock(Expandable, {
                            key: 0,
                            "icon-class": view.value.fullSummaryCss(),
                            title: __props.doc.fullSummaryItemText,
                            "default-open": true,
                            class: "control-menu__full-summary"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.doc.pages.slice(1), (page) => {
                                return (_openBlock(), _createElementBlock("li", {
                                  key: page.order,
                                  class: _normalizeClass(["control-menu__sub-unit", view.value.chapterWrapperCss(page)])
                                }, [
                                  _createVNode(_component_router_link, {
                                    replace: "",
                                    to: view.value.chapterLink(page),
                                    class: "control-menu__sub-link",
                                    onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (view.value.menuItemClick()), ["stop"]))
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("span", {
                                        class: _normalizeClass(["control-menu__icon iconfont", view.value.chapterCss(page)])
                                      }, null, 2),
                                      _createElementVNode("span", null, _toDisplayString(page.title), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["to"])
                                ], 2))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["icon-class", "title"]))
                        : _createCommentVNode("", true),
                      _createElementVNode("li", {
                        class: _normalizeClass(["control-menu__unit", {
                  'control-menu__unit--active': __props.doc.isCurrentHighlights(),
                }])
                      }, [
                        _createVNode(_component_router_link, {
                          replace: "",
                          to: {
                    name: __props.doc.routeNames().highlights,
                    params: { url_slug: __props.doc.url_slug },
                  },
                          class: "control-menu__link"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_7,
                            _hoisted_8
                          ]),
                          _: 1
                        }, 8, ["to"])
                      ], 2),
                      _createVNode(Expandable, {
                        "icon-class": "iflag control-menu__icon-bookmark",
                        title: "Bookmarks",
                        class: "control-menu__unit-bookmarks"
                      }, {
                        default: _withCtx(() => [
                          (__props.doc.bookmarks.length === 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
                            : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(__props.doc.bookmarks, (bookmark) => {
                                return (_openBlock(), _createElementBlock("li", {
                                  key: bookmark.id,
                                  class: "control-menu__sub-unit control-menu__bookmarks"
                                }, [
                                  _createVNode(_component_router_link, {
                                    replace: "",
                                    to: view.value.bookmarkLink(bookmark),
                                    class: "control-menu__sub-link",
                                    onClick: [
                                      _cache[3] || (_cache[3] = _withModifiers(($event: any) => (view.value.menuItemClick()), ["stop"])),
                                      ($event: any) => (view.value.bookmarkClick(bookmark))
                                    ]
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_12,
                                      _createElementVNode("span", _hoisted_13, _toDisplayString(bookmark.quote), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["to", "onClick"])
                                ]))
                              }), 128))
                        ]),
                        _: 1
                      }),
                      _createElementVNode("li", {
                        class: _normalizeClass(["control-menu__unit", {
                  'control-menu__unit--active': __props.doc.isCurrentCommunity(),
                }])
                      }, [
                        _createVNode(_component_router_link, {
                          replace: "",
                          to: {
                    name: __props.doc.routeNames().community,
                    params: { url_slug: __props.doc.url_slug },
                  },
                          class: "control-menu__link"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_14,
                            _hoisted_15
                          ]),
                          _: 1
                        }, 8, ["to"])
                      ], 2),
                      _createVNode(NativeStorageDownloadButton, { "native-storage-view": nativeStorageView.value }, null, 8, ["native-storage-view"]),
                      (nativeStorageView.value?.error)
                        ? (_openBlock(), _createElementBlock("li", _hoisted_16, [
                            _createElementVNode("span", _hoisted_17, _toDisplayString(nativeStorageView.value.error), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ], 2), [
                    [_vShow, view.value.isVisible]
                  ])
                ]),
                _: 1
              })
            ], 512), [
              [_vShow, view.value.isVisible]
            ])
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}
}

})